import { Dayjs } from 'dayjs';
import { Page } from '../models/Elements';
import { TrapMetric, TrapMetricStats } from '../models/Entities';
import { StatsDateType } from '../models/Types';
import dateService from '../services/DateService';
import { coreApiAxios } from './CustomAxios';

class TrapMetricApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        companyId?: number,
        trapPlotId?: number,
        trapId?: number,
        searchText?: string
    ): Promise<Page<TrapMetric>> => {
        const response = await coreApiAxios.get<Page<TrapMetric>>('/trap-metrics', {
            params: { page, size, sortField, sortOrder, companyId, trapPlotId, trapId, searchText, status: 'ENABLED' }
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((trapMetric) => this.loadDates(trapMetric));

        return response.data;
    };

    listStats = async (
        startDate: Dayjs,
        endDate: Dayjs,
        statsDateType: StatsDateType,
        companyId?: number,
        plotId?: number,
        trapPlotId?: number
    ): Promise<TrapMetricStats[]> => {
        const response = await coreApiAxios.get<TrapMetricStats[]>('/trap-metrics/stats', {
            params: { startDate: startDate.toJSON(), endDate: endDate.toJSON(), statsDateType, companyId, plotId, trapPlotId }
        });
        response.data.forEach((trapMetricStatsByTrap) => this.loadDatesTrapMetricStatsByTrap(trapMetricStatsByTrap));

        return response.data;
    };

    get = async (trapMetricId: number): Promise<TrapMetric> => {
        const response = await coreApiAxios.get<TrapMetric>(`/trap-metrics/${trapMetricId}`);
        this.loadDates(response.data);

        return response.data;
    };

    update = async (trapMetric: TrapMetric): Promise<TrapMetric> => {
        const response = await coreApiAxios.put<TrapMetric>(`/trap-metrics/${trapMetric.id}`, trapMetric);
        this.loadDates(response.data);

        return response.data;
    };

    delete = async (trapMetricId: number): Promise<void> => {
        const response = await coreApiAxios.delete<void>(`/trap-metrics/${trapMetricId}`);

        return response.data;
    };

    /**
     * Loads the dates of a trap.
     * @param trap - the trap
     */
    private loadDates(trapMetric: TrapMetric) {
        trapMetric.date = dateService.transformDate(trapMetric.date)!;
        trapMetric.audit!.created = dateService.transformDate(trapMetric.audit!.created)!;
        trapMetric.audit!.updated = dateService.transformDate(trapMetric.audit!.updated)!;
    }

    /**
     * Loads the dates of a trap metric stats by trap.
     * @param trapMetricStatsByTrap - the trap metric stats by trap
     */
    private loadDatesTrapMetricStatsByTrap(trapMetricStats: TrapMetricStats) {
        trapMetricStats.date = dateService.transformDate(trapMetricStats.date)!;
    }
}

const trapMetricApi: TrapMetricApi = new TrapMetricApi();
export default trapMetricApi;
